import React from "react";


const EPrecommendations = () => {
  document.title = "ep-recommendations";

  return (
    <React.Fragment>
      <div className="page-content">

        <h1>ep-recommendations</h1>
        
      </div>
    </React.Fragment>
  );
};

export default EPrecommendations;
